// @flow
import styled, { css } from 'styled-components';

const inputCss = css`
  border: 0;
  line-height: normal;
  -webkit-appearance: none;
  ::-webkit-input-placeholder {
    opacity: 1 !important;
    color: var(--color-grey-4);
  }
`;

export const TextInput = styled.input.attrs(({ type = 'text' }) => ({
  type,
}))`
  ${inputCss};
`;

export const TextareaInput = styled.textarea.attrs({
  type: 'text',
})`
  ${inputCss};
`;

export const NumberInput = styled.input.attrs(
  ({
    type = 'text',
    placeholder = 'Enter Amount',
    inputMode = 'numeric',
    noValidate = true,
  }) => ({
    type,
    placeholder,
    inputMode,
    noValidate,
  }),
)`
  ${inputCss};
`;
